window.Mailjet = {
	loadPrefs : function(){
		window.sellsyapp.config.globalProperties.$store.state.popupPanel.popupMailjetSettings.props = { mode: 'settings' }
		window.sellsyapp.config.globalProperties.$store.state.popupPanel.popupMailjetSettings.display = true
	},
};
